import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useT } from '../lib/i18n';
import ThemeToggle from './ThemeToggle';
import LanguageSwitcher from './LanguageSwitcher';
import WalletChip from './WalletChip';

export default function NavBar() {
  const { user } = useAuth();
  const t = useT();
  return (
    <header
      className="sticky top-0 z-30 backdrop-blur bg-white/75 dark:bg-arena-900/75
                 border-b border-arena-200/60 dark:border-arena-600/40
                 pt-[env(safe-area-inset-top)]"
    >
      <div className="max-w-xl mx-auto flex items-center gap-2 px-3 h-12">
        <Link to="/" className="flex items-center gap-2 font-extrabold min-w-0">
          <img src="/icons/icon-96.png" alt="" className="w-7 h-7 rounded-lg shrink-0" />
          <span className="text-arena-700 dark:text-neon-300 text-sm tracking-wide truncate">{t('nav.brand')}</span>
        </Link>
        <div className="flex-1" />
        {user ? <WalletChip /> : null}
        <LanguageSwitcher />
        <ThemeToggle />
        {!user && (
          <Link to="/login" className="btn-primary px-3 py-1.5 text-sm">{t('common.signIn')}</Link>
        )}
      </div>
    </header>
  );
}
